import { useEffectOnce, useQueryState } from 'core/use-cases/utilities';

import { useCheckoutCommand } from '../commands';
import {
  useCheckoutPropertyByKeySelector,
  useCheckoutSelectors,
  usePaymentDetailSelector,
  usePaymentMethodsSelector,
  usePaymentOptionSelectors,
  useSummarySelector,
} from '../selectors';

import type { Checkout } from 'core/domains';

/**
 * Controller initial Flow from Checkout
 *
 */
export function useCheckoutInitFlow() {
  const { initCheckoutFlow, setPaymentMethodStatus } = useCheckoutCommand();

  useEffectOnce(() => {
    initCheckoutFlow();

    return () => {
      setPaymentMethodStatus();
    };
  });
}

export function useCheckout() {
  const data = useCheckoutSelectors();

  return data;
}

/**
 * Receive a key and return info of checkout context
 *
 */
export function useCheckoutPropertyByKey<T extends keyof Checkout>(key: T) {
  const data = useCheckoutPropertyByKeySelector(key);

  return data as Checkout[typeof key];
}

export function usePaymentDetail() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(usePaymentDetailSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

/**
 * Responsible for fetching the payment methods
 *
 */
export function usePaymentMethods() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(usePaymentMethodsSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

/**
 * Responsible for return the payment option
 *
 */

export function usePaymentOption() {
  const data = usePaymentOptionSelectors();

  return data;
}

/**
 * Responsible for returning the summary of the values the cart
 *
 */

export function useSummary() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useSummarySelector);

  return { data, isError, isIdle, isLoading, isSuccess };
}
